/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class KeyValuePair {
    getFixupPrototypeFunction() { return KeyValuePair.fixupPrototype; }

    static newInstance(model: Partial<KeyValuePair>): KeyValuePair {
        let obj = Object.assign(new KeyValuePair(), model);
        KeyValuePair.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<KeyValuePair>): KeyValuePair {
        if (!model) return null;
        return KeyValuePair.newInstance(<KeyValuePair> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: KeyValuePair) {
        if (!obj) return;

        models.KeyValuePair.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: KeyValuePair): boolean {
        Object.setPrototypeOf(obj, KeyValuePair.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Key of the pair
     */
    key: string;

    /**
     * Value of the pair
     */
    value: string;

}
